$(function() {
    // ajax params
    let myajax = `//${window.location.host}/wp-admin/admin-ajax.php`,
        paramObj = {
            action: 'ajax_press_pagination',
            postType: 'press',
            url: myajax,
            catId: 'all',
            currentPage: 1,
            order: 'DESC'
        };

    // Ajax helper function
    function loadPosts(paramObj) {
        let postsOffsetTop = $('.js-press-list').offset().top - document.querySelector('.page-header').offsetHeight;
        $.ajax({
            url: paramObj.url,
            data: paramObj,
            type: 'POST',
            beforeSend() {
                $('.js-press-list').css({ 'opacity': '.3', 'pointer-events': 'none' });
            },
            success(data) {
                $('html, body').animate({ scrollTop: `${postsOffsetTop}` }, 500);
                $('.js-press-list').html(data);
            },
            complete() {
                $('.js-press-list').css({ 'opacity': '1', 'pointer-events': 'auto' });
            }
        });
    }

    //Pagination
    $('.js-press-list').on('click', '.page-numbers', function H(e) {
        e.preventDefault();
        paramObj.currentPage = Number($(this).html());
        if ($(this).hasClass('next')) {
            paramObj.currentPage =+ Number($('.current').html()) + 1;
        }
        if ($(this).hasClass('prev')) {
            paramObj.currentPage = +Number($('.current').html()) - 1;
        }
        loadPosts(paramObj);
    });
});